import { render, staticRenderFns } from "./TPanelHeader.vue?vue&type=template&id=b70ed186&scoped=true&"
import script from "./TPanelHeader.vue?vue&type=script&lang=js&"
export * from "./TPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./TPanelHeader.vue?vue&type=style&index=0&id=b70ed186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ed186",
  null
  
)

/* custom blocks */
import block0 from "./TPanelHeader.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports